import {
  IMAGE_MANIFEST,
  ImageSources,
  ImageKey,
} from "@/images/generated/manifest";

interface ProjectDemo {
  /** Public URL that is framable (no X-Frame-Options / CSP frame-ancestors) and auth-free. */
  url: string;
  /** Device chrome to render around the iframe. */
  frame: "phone" | "browser";
}

export interface Project {
  // Keyed to the generated manifest so a renamed/missing image is a compile error.
  key: ImageKey;
  slug: string;
  name: string;
  img: ImageSources;
  liveUrl: string;
  tags: readonly string[];
  featured: boolean;
  /** When present, enables the click-to-run live-demo embed on the case study page. */
  demo?: ProjectDemo;
}

export const PROJECTS: readonly Project[] = [
  {
    key: "patitas",
    slug: "patitas",
    name: "Patitas",
    img: IMAGE_MANIFEST.patitas,
    liveUrl: "https://patitas.devbloom.dev",
    tags: ["PWA", "Wompi", "Shelter Ops", "Gemini"],
    featured: true,
    demo: { url: "https://patitas.devbloom.dev", frame: "phone" },
  },
  {
    key: "staged",
    slug: "staged",
    name: "Staged",
    img: IMAGE_MANIFEST.staged,
    liveUrl: "https://staged.devbloom.dev",
    tags: ["iOS", "Expo", "Multipeer", "TestFlight"],
    featured: false,
  },
  {
    key: "bloomAssistant",
    slug: "bloom-assistant",
    name: "Bloom Assistant",
    img: IMAGE_MANIFEST.bloomAssistant,
    liveUrl: "https://chat.devbloom.dev",
    tags: ["PWA", "Claude AI", "Firebase", "Ionic React"],
    featured: false,
  },
  {
    key: "devflow",
    slug: "devflow",
    name: "DevFlow",
    img: IMAGE_MANIFEST.devflow,
    liveUrl: "https://devflow.devbloom.dev",
    tags: ["TypeScript", "Node.js", "Commander.js", "Open Source"],
    featured: false,
  },
  {
    key: "toller",
    slug: "toller",
    name: "Toller",
    img: IMAGE_MANIFEST.toller,
    liveUrl: "https://toller.devbloom.dev",
    tags: ["Maps", "Realtime", "Geospatial"],
    featured: false,
    demo: { url: "https://toller.devbloom.dev", frame: "phone" },
  },
  {
    key: "spectra",
    slug: "spectra",
    name: "Spectra",
    img: IMAGE_MANIFEST.spectra,
    liveUrl: "https://spectra.devbloom.dev",
    tags: ["Gemini Vision", "Creative AI"],
    featured: false,
    demo: { url: "https://spectra.devbloom.dev", frame: "browser" },
  },
  {
    key: "expenseTracker",
    slug: "expense-tracker",
    name: "Expense Tracker",
    img: IMAGE_MANIFEST.expenseTracker,
    liveUrl: "https://expenses.devbloom.dev",
    tags: ["OCR", "PWA", "Budgets"],
    featured: false,
  },
  {
    key: "atrium",
    slug: "atrium",
    name: "Atrium",
    img: IMAGE_MANIFEST.atrium,
    liveUrl: "https://atrium.devbloom.dev",
    tags: ["NestJS", "Prisma", "React", "Multi-tenant"],
    featured: false,
  },
] as const;

export function findProjectBySlug(slug: string): Project | undefined {
  return PROJECTS.find((p) => p.slug === slug);
}
